import AmazonSFPConfigComponent from './AmazonSFPConfigComponent'
import { Button, ButtonGroup, Col, Container, Row, Tab, Tabs, ToggleButton } from 'react-bootstrap'
import { useMemo, useState } from 'react'
import { InteractiveBrowserCredential } from '@azure/identity'
import { TENANT_ID, CLIENT_ID } from '../authConfig'
import { BlobServiceClient } from '@azure/storage-blob'
import { DATA_SERVICES_BLOBS_DEV, DATA_SERVICES_BLOBS } from '../common/common.constants'

const RADIO = [
  { name: 'Development', value: 'development', enabled: true },
  { name: 'Production', value: 'production', enabled: true }
]

const ConfigComponent = () => {
  const [environment, setEnvironment]: [string, any] = useState('production')

  const credential = new InteractiveBrowserCredential({
    tenantId: TENANT_ID,
    clientId: CLIENT_ID,
    authorityHost: 'https://login.microsoft.com'
  })

  const view = useMemo(() => {
    const blobServiceClient = new BlobServiceClient(environment === 'development' ? DATA_SERVICES_BLOBS_DEV : DATA_SERVICES_BLOBS, credential)
    const containerClient = blobServiceClient.getContainerClient('storage')

    return (
      <>
<Container className="my-4"> {/* Removed text-center */}
  <div className="text-center">
    <h2>Configurations</h2>
    <Row className="justify-content-center mt-3">
      <Col xs="auto">
        {RADIO.map((radio, idx) => (
          <Button
            key={idx}
            variant={
              environment === radio.value
                ? idx % 2
                  ? 'success'
                  : 'danger'
                : idx % 2
                ? 'outline-success'
                : 'outline-danger'
            }
            onClick={() => setEnvironment(radio.value)}
            disabled={radio.enabled !== true}
            active={environment === radio.value}
            className="mx-1"
          >
            {radio.name}
          </Button>
        ))}
      </Col>
    </Row>
  </div>
  
  <Tabs defaultActiveKey="amazonSfp" id="config-tabs" className="mb-3">
    <Tab eventKey="amazonSfp" title="Amazon SFP Configurations">
      <AmazonSFPConfigComponent containerClient={containerClient} />
    </Tab>
  </Tabs>
</Container>
      </>
    )
  }, [environment])

  return view
}

export default ConfigComponent